
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stripe-integration",
      function () {
        return require("private-next-pages/stripe-integration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stripe-integration"])
      });
    }
  